import PropTypes from 'prop-types'
import { Conditional } from 'iq-blueberry'
import * as classNames from 'classnames'

import useTokenInput from './hook'
import './style.styl'

const TokenInput = ({
  size = 6,
  onCompleteToken,
  onChange,
  timer,
  onChangeTimer,
  isError,
  errorMessage,
}) => {
  const { tokenMap, onChangeNumber, onKeyUpHandler, rootElementRef } =
    useTokenInput({
      size,
      onChange,
      onCompleteToken,
      timer,
      onChangeTimer,
    })

  const numerals = ['Primeiro', 'Segundo', 'Terceiro', 'Quarto', 'Quinto']

  return (
    <div className='token-input-container'>
      <div className="token-input" ref={rootElementRef}>
        {[...Array(size)].map((_, i) => (
          <div
            className="token-input__input-holder"
            key={`token-digit-${i}`}>
            <input
              aria-label={`${numerals[i]} dígito do token`}
              type="text"
              maxLength="1"
              value={tokenMap[i]}
              className={classNames("input-field__input", {
                "input-field__input--error" : isError
              })}
              onChange={(e) => onChangeNumber(e, i)}
              onKeyUp={(e) => onKeyUpHandler(e, i)}
              data-token-i={i}
            />
          </div>
        ))}
      </div>
      <Conditional
        condition={isError}
        renderIf={<strong className='message-error'>{errorMessage}</strong>}
      />
    </div>
  )
}

TokenInput.propTypes = {
  size: PropTypes.number.isRequired,
}

export default TokenInput
